import React from 'react'
import Header from './Header'
import Footer from './Footer'
import Portfolio from './Portfolio'
function Potfolio() {
  return (
    <div>
      <Header />
      <Portfolio />
      <Footer />
    </div>
  )
}

export default Potfolio
